import { render, staticRenderFns } from "./PackagesFnoCats.vue?vue&type=template&id=b5c31b90&"
import script from "./PackagesFnoCats.vue?vue&type=script&lang=js&"
export * from "./PackagesFnoCats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports